import TenantConfig from '@framework/tenant/TenantConfig';

export interface IFeatureToggleItem {
  cookieName: string,
  isEnabled?: boolean,
}

export interface IFeatureToggle {
  [key: string]: IFeatureToggleItem,
}

export const getFeatureToggleConfig = (hostname = '') => {
  return TenantConfig.fromHostname(hostname).featureToggle || {};
};

export const getFeatureToggleCalculatedList = (
  cookies: Record<string, string>,
  featuresList: Record<string, any>,
): IFeatureToggle => {
  const features: Record<string, any> = {};
  Object.keys(featuresList).forEach((featureName) => {
    features[featureName] = {
      ...featuresList[featureName],
      isEnabled: !!cookies[featuresList[featureName].cookieName],
    };
  });
  return features;
};
